import * as React from "react";
import DocumentEditor from "./DocumentEditor/DocumentEditor";
import SpreadsheetEditor from "./DocumentEditor/SpreadsheetEditor";
import PdfViewer from "./DocumentEditor/PdfViewer";
import { downloadFileByID } from "../../../app/api/axios/services/files.service";

const DocumentPreview = ({ fileId, fileName, data }) => {
  const hasFetched = React.useRef(false);
  const documentEditorRef = React.useRef(null);
  const [file, setFile] = React.useState(null);

  React.useEffect(() => {
    if (hasFetched.current) return;
    async function fetchData() {
      try {
        let f = await downloadFileByID(fileId); // Download file with id
        setFile(f);
      } catch (error) {
        console.log("error :>> ", error);
      }
    }
    // Only fetch data if fileId exists
    if (fileId) {
      fetchData();
    }
    hasFetched.current = true; // Set the flag to true after the effect runs
  }, [fileId]); // Dependency array with the file ID

  return (
    <div style={{ minWidth: "100%", minHeight: "80vh" }}>
      {fileName.includes(".doc") && file && (
        <DocumentEditor
          data={data}
          file={file}
          preview={true}
          documentEditorRef={documentEditorRef}
        />
      )}
      {fileName.includes(".xls") && <SpreadsheetEditor data={data} />}
      {fileName.includes(".pdf") && <PdfViewer data={data} />}
    </div>
  );
};

export default DocumentPreview;
